import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';


export const SkeletonVideo = () => (
  <Skeleton height={400} variant="rect" width="100%" />
);